import TimingClock from '../../components/TimingClock';
import DimmerPopup from '../../components/DimmerPopup';
import NumberInput from '../../components/NumberInput';
import { Button, Form, Label, Table } from '../../components';
import { computeCallingOrder } from '../../rules/callingOrder';
import {
  liftsSelector,
  eventsSelector,
  protocolsSelector,
} from '../../orm/selectors';
import ormActions from '../../orm/actions';
import venueActions from '../../venue/actions';
import { bickActions, formatName } from '../../common';

//import Fullscreen from 'react-full-screen';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { createSelector } from 'reselect';
import { find, get, invoke, map, pick } from 'lodash';

const StartNumberCell = ({ startNumber }) => (
  <Table.Cell>
    <Label basic>{startNumber}</Label>
  </Table.Cell>
);

class DeclarationPopup extends Component {
  state = { open: false, weight: this.props.weight };
  setOpen = open => this.setState({ open });
  onOpen = () => this.setOpen(true);
  onClose = () => this.setOpen(false);
  onInputChange = (event, { value }) => {
    this.setState({ weight: value });
  };
  onInputFocus = event => {
    event.target.select();
  };
  onSubmit = () => {
    this.setOpen(false);
    const { weight } = this.state;
    invoke(this.props, 'actions.declaration', weight);
  };

  render() {
    const { startNumber, trigger, weight } = this.props;
    const { open } = this.state;
    return (
      <DimmerPopup
        on="click"
        open={open}
        onOpen={this.onOpen}
        onClose={this.onClose}
        trigger={trigger}
      >
        <Form onSubmit={this.onSubmit}>
          <Form.Input>
            <NumberInput
              value={weight}
              precision={0}
              onChange={this.onInputChange}
              onFocus={this.onInputFocus}
              autoFocus
              action
            >
              <Label size="large" basic>
                <strong>#{startNumber}</strong>
              </Label>
              <input />
              <Button content="Change" />
            </NumberInput>
          </Form.Input>
        </Form>
      </DimmerPopup>
    );
  }
}

const TableRow = ({ row }) => {
  const disabled = !row.currentDeclaredWeight;
  const trigger = (
    <Button
      disabled={disabled}
      content={row.currentDeclaredWeight || '---'}
      style={{ textAlign: 'right' }}
      fluid
      basic
    />
  );

  return (
    <Table.Row disabled={disabled}>
      <StartNumberCell startNumber={row.startNumber} />
      <Table.Cell>{row.name}</Table.Cell>
      <StartNumberCell startNumber={row.startNumber} />
      <Table.Cell>
        <DeclarationPopup
          trigger={trigger}
          startNumber={row.startNumber}
          weight={row.currentDeclaredWeight}
          actions={row.actions}
        />
      </Table.Cell>
    </Table.Row>
  );
};

const Marshal = ({ currentProtocol, currentLift, timingClock, actions }) => {
  const rows = map(get(currentProtocol, 'athletes'), athlete => {
    const lastAttemptNumber = get(
      athlete.lastAttemptByLiftId,
      [currentLift.id, 'number'],
      0,
    );
    const lastDeclaration = get(athlete.lastDeclarationByLiftId, [
      currentLift.id,
    ]);

    const clearDeclarations = () => {
      const { destroy } = actions.orm.declaration;

      const attemptNumber = get(lastDeclaration, 'attemptNumber', 1);
      const declarations = get(athlete.declarationsByLiftId, [currentLift.id]);
      for (const declaration of declarations) {
        if (declaration.attemptNumber !== attemptNumber) continue;
        const { primaryKey } = declaration;
        destroy(Object.values(primaryKey));
      }
    };

    return {
      ...pick(athlete, 'startNumber'),
      key: athlete.id,
      name: formatName(athlete.entry),
      currentDeclaredWeight:
        lastDeclaration && lastDeclaration.attemptNumber > lastAttemptNumber
          ? lastDeclaration.weight
          : undefined,
      actions: {
        declaration: weight => {
          const { upsert } = actions.orm.declaration;

          const primaryKey = {
            athlete: athlete.primaryKey,
            lift: currentLift.primaryKey,
            attemptNumber: get(lastDeclaration, 'attemptNumber', 1),
            changeNumber: get(lastDeclaration, 'changeNumber', 0) + 1,
          };

          console.log('DECL', weight);

          if (!weight) clearDeclarations();
          else upsert({ ...primaryKey, weight });
        },
      },
    };
  });

  return (
    <main>
      <h1>Marshal terminal</h1>
      <div style={{ display: 'inline-block', float: 'right' }}>
        <TimingClock {...timingClock} />
      </div>
      <Table compact="very">
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>Nr</Table.HeaderCell>
            <Table.HeaderCell>Name</Table.HeaderCell>
            <Table.HeaderCell width={1}>Nr</Table.HeaderCell>
            <Table.HeaderCell width={1}>Declared weight</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rows.map(row => (
            <TableRow key={row.key} row={row} />
          ))}
        </Table.Body>
      </Table>
    </main>
  );
};

Marshal.slug = 'marshal';
Marshal.title = 'Marshal';

const mapStateToProps = () => {
  const callingOrderSelector = createSelector(
    ({ protocol }) => get(protocol, 'athletes', []),
    ({ lift }) => get(lift, 'id', -1),
    ({ event }) => get(event, 'mode', 'default'),
    (athletes, liftId, mode) => {
      if (!athletes.length || liftId === -1) return [];
      return computeCallingOrder(athletes, liftId, mode);
    },
  );

  return ({ orm, venue }, ownProps) => {
    const lifts = liftsSelector(orm);
    const events = eventsSelector(orm);
    const protocols = protocolsSelector(orm);
    const { current } = venue.competition;

    const [currentEvent] = events;

    const currentProtocol = find(protocols, {
      primaryKey: current.protocol,
    });
    const currentLift = find(lifts, { primaryKey: current.lift });

    return {
      orm: {
        lifts,
      },
      currentProtocol,
      currentLift,
      callingOrder: callingOrderSelector({
        protocol: currentProtocol,
        lift: currentLift,
        event: currentEvent,
      }),
      ...pick(venue.competition, 'timingClock'),
    };
  };
};

const mapDispatchToProps = dispatch => ({
  actions: {
    orm: bickActions(ormActions, ['declaration'], dispatch),
    venue: bickActions(venueActions.competition, ['timingClock'], dispatch),
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Marshal);



// WEBPACK FOOTER //
// ./src/terminals/Marshal/index.js